"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ArrayIndex = void 0;
const core_1 = require("flow-connect/core");
class ArrayIndex extends core_1.Node {
    constructor() {
        super();
    }
    setupIO() {
        this.addTerminals([
            { type: core_1.TerminalType.IN, name: "data", dataType: "array" },
            { type: core_1.TerminalType.IN, name: "index", dataType: "number" },
            { type: core_1.TerminalType.OUT, name: "value", dataType: "any" },
        ]);
    }
    created(options) {
        const { style = {}, name = "Array Index", width = 120 } = options;
        this.width = width;
        this.name = name;
        this.style = Object.assign({ rowHeight: 10 }, style);
    }
    process(inputs) {
        if (!inputs || !inputs[0] || typeof inputs[1] !== "number")
            return;
        this.setOutputs(0, inputs[0][inputs[1]]);
    }
}
exports.ArrayIndex = ArrayIndex;
